import React from 'react';
import numeral from 'numeral';
import styles from 'styles/components/lib/tables/dnd/dndTotalHeader.css';

const DNDTotalHeader = (props) => (
  <div className={props.print ? styles.containerPrint : styles.container}>
    {/* classNames with PRINT at the end are only rendered during print */}
    {/* displaying tickets data and packages data respectively next to each other */}
    <div className={styles.totalBox}>
      {/* REG BOX - for both tickets and packages QTY */}
      <div className={styles.item}>
        <h5>TOTAL QUANTITY</h5>
        <h5>{props.hasData ? props.data.qty : 0}</h5>
      </div>
      {/* PRINT BOX for TICKET QTY */}
      <div className={styles.itemPrint}>
        <h5>TOTAL TICKET QUANTITY</h5>
        <h5>{props.ticketData.qty}</h5>
      </div>
      <div className={styles.divider}></div>
      {/* DIVIDER for PRINT */}
      <div className={styles.dividerPrint}></div>
      {/* REG BOX - for both tickets and packages REVENUE */}
      <div className={styles.item}>
        <h5>TOTAL REVENUE</h5>
        <h5>${props.hasData ? numeral(props.data.revenue).format('0,0.00') : 0.00}</h5>
      </div>
      {/* PRINT BOX for TICKET REVENUE */}
      <div className={styles.itemPrint}>
        <h5>TOTAL TICKET REVENUE</h5>
        <h5>${numeral(props.ticketData.revenue).format('0,0.00')}</h5>
      </div>
      {/* DIVIDER for PRINT */}
      <div className={styles.dividerPrint}></div>
      {/* PRINT BOX for PACKAGE QTY */}
      <div className={styles.itemPrint}>
        <h5>TOTAL PACKAGE QUANTITY</h5>
        <h5>{props.packageData.qty}</h5>
      </div>
      {/* DIVIDER for PRINT */}
      <div className={styles.dividerPrint}></div>
      {/* PRINT BOX for PACKAGE REVENUE */}
      <div className={styles.itemPrint}>
        <h5>TOTAL PACKAGE REVENUE</h5>
        <h5>${numeral(props.packageData.revenue).format('0,0.00')}</h5>
      </div>
    </div>
  </div>
);

export default DNDTotalHeader;


// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDTotalHeader.js